import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class GetServerWorkStateRequest extends Request {
    constructor() {
        super({
            req: RequestTypes.GET_SERVER_WORK_STATE,
            req_id: 0
        });
    }
}

export default GetServerWorkStateRequest;